import { useTranslation } from '@thoughtspot/i18n';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Radio } from '@thoughtspot/radiant-react/widgets/radio';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import { get } from 'lodash';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
const RadioLabelComponent = ({ label }) => {
    return (React.createElement(Typography, { variant: "p-small-bold", className: styles.radioLabel }, label));
};
export const RadioFormComponent = ({ label, elementKey, onChange, selectedValue, defaultValue, values, isDisabled = false, }) => {
    const { t } = useTranslation();
    let selectedVal = selectedValue;
    if (!selectedVal && typeof defaultValue === 'string') {
        selectedVal = defaultValue;
    }
    else if (!selectedVal && typeof defaultValue === 'object') {
        selectedVal = defaultValue.value;
    }
    const onChangeRadio = (e) => {
        onChange(elementKey, get(e, 'target.value'));
    };
    return (React.createElement(FormControl, { label: React.createElement(RadioLabelComponent, { label: label }), className: styles.formComponentItem, noMarginBottom: true, "data-testid": `test-id-${elementKey}` },
        React.createElement(Radio.Group, { id: "radio_group", key: elementKey, onChange: onChangeRadio, selectedValue: selectedVal, orientation: "list", disabled: isDisabled }, values.map(value => {
            let displayValue = '';
            let key = '';
            if (typeof value === 'string') {
                displayValue = value;
                key = value;
            }
            else if (typeof value === 'object') {
                displayValue = value.valueTranslation
                    ? t(value.valueTranslation)
                    : value.value;
                key = value.value;
            }
            return (React.createElement(Radio, { id: displayValue, label: displayValue, value: key, key: key, disabled: isDisabled }));
        }))));
};
//# sourceMappingURL=radio-form.component.js.map